/* @flow */
import type { Map } from 'immutable';
import createDebugger from 'debug';
const debug = createDebugger('app:modules:marketplace:actions'); // eslint-disable-line no-unused-vars

import type { RawOptions } from './types.js';
import {
  REGISTER_ACTIVITY,
  SET_DISPLAY_OPTIONS,
} from './action-types.js';


/**
 * Register Marketplace activty to APM event
 */
export const registerActivity = (payload: Object) => ({
  type: REGISTER_ACTIVITY,
  payload,
});

/**
 * Set display options. Determines sorting and filtering of Marketplace.
 * NOTE: These Display Options aggregate those from the data-feeds and subscriptions modules
 */
export const setDisplayOptions = (options: RawOptions): Object => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});



// WEBPACK FOOTER //
// ./src/app/modules/marketplace/actions.js